import styled, { css } from 'styled-components';

export const baseElementStyling = css`
  box-sizing: border-box;
  border: 1px solid ${({ theme }) => theme.color.borderColor};
  border-radius: ${(props) => props.theme.radius.sm};
  overflow: hidden;
  transition: all 0.2s;
  padding: 0.8rem 2rem 0.8rem 1rem;
  color: ${({ theme }) => theme.color.bodyTextColor};

  &:focus {
    outline-color: ${({ theme }) => theme.color.primary};
  }
  &::placeholder {
    color: ${({ theme }) => theme.color.muted};
  }
`;

export const StyledInput = styled.input`
  ${baseElementStyling}
`;

export const StyledTextArea = styled.textarea`
  min-height: 10rem;
  ${baseElementStyling}
`;

export const StyledSelect = styled.select`
  ${baseElementStyling}
`;

export const StyledRadioButton = styled.input`
  margin-right: 10px;

  &:checked {
    background-color: ${({ theme }) => theme.color.primary};
  }
  &:hover {
    cursor: pointer;
  }
`;

export const StyledLabel = styled.label`
  color: ${({ theme }) => theme.color.bodyTextColor};
  font-weight: 600;
`;

export const StyledRequiredSpan = styled.span`
  color: ${({ theme }) => theme.color.error};
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.color.error};
`;
